import request from '../utils/request'

export function listSelf(data) {
    return request({
        url: '/api/expertOrders/list_self?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&is_pay='+data.is_pay,
        method: 'get'
    })
}

export function expertPay(data) {
    return request({
        url: '/api/expert/pay',
        method: 'post',
        data
    })
}


export function listcompany(data) {
    return request({
        url: '/api/open/uni/listcompany3?pageSize='+data.pageSize+'&pageNum='+data.pageNum,
        method: 'get'
    })
}

// export function listremark(data){
//     return request({
//         url: '/api/open/uni/listremark?xcate='+data.xcate+'&xid='+data.xid+'&pageSize='+data.pageSize,
//         method: 'get'
//     })
// }

// export function orderOn(data){
//     return request({
//         url: '/api/orderitem/list?order_no='+data.order_no+'&product_type='+data.product_type,
//         method: 'get'
//     })
// }

// export function getExpress(data){
//     console.log("getExpress--");
//     console.log(data);
//     return request({
//         url: '/api/orderExpress/getExpress',
//         method: 'post',
//         data
//     })
// }